export default __webpack_public_path__ + "static/media/TITULOS_01.7d3cbfd3.png";